(function () {
  'use strict';

  function initSocialGlass(section) {
    var dock = section.querySelector('[data-social-dock]');
    var toggle = section.querySelector('[data-social-toggle]');
    var icons = Array.prototype.slice.call(section.querySelectorAll('[data-social-icon]'));

    if (dock && toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dock.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      document.addEventListener('click', function (e) {
        if (!dock.contains(e.target)) {
          dock.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    icons.forEach(function (icon) {
      icon.addEventListener('click', function () {
        icon.classList.remove('is-clicked');
        void icon.offsetWidth; // restart animation if clicked rapidly
        icon.classList.add('is-clicked');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-social-glass]').forEach(initSocialGlass);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-social-glass]');
    if (section) initSocialGlass(section);
  });
})();